module.exports = __webpack_public_path__ + "static/cooking-d00f3e68dd5b7b072b05bb717e317cde.jpg";